import { render, staticRenderFns } from "./RevokeSecgroup.vue?vue&type=template&id=6dedd0d1&"
import script from "./RevokeSecgroup.vue?vue&type=script&lang=js&"
export * from "./RevokeSecgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports